module.exports = Global;


//////////////////
// WEBPACK FOOTER
// external "Global"
// module id = 2
// module chunks = 0 2 3